import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'

// import * as mixpanel from 'mixpanel-browser'

import ITalentsData from 'data/abitilies/interfaces/ITalentsData'

import { TChildListener } from 'components/ChildListener/context'
import { isEqual } from 'lodash'
import { _route } from 'routes/config'
// import { getGamesCount } from 'services/games'

import { Circle, HistoryModal, ReavaluateModal, ShareModal } from 'components'
import { bindActionCreators } from 'redux'
import { checkForNewAssessment } from 'services/historyMode/historyMode'
import { IStorageData } from 'services/historyMode/types'
import { getAssessmentKeysArr, getCurrentAssessment } from 'services/patient'
import * as PatientActions from 'store/patients/actions'
import IChild from 'types/database/children/child'
import Content from './content'
import './style.scss'

interface INativeProps {
  childListener?: TChildListener
}

interface IReduxDispatchProps {
  PatientsLib: any
}

interface IReduxStateProps {
  user: any
  currentPatient: any
  userAuth: any
  plusUser: any
  talentsChartData: any
}

interface IReduxProps extends IReduxStateProps {}

interface IState {
  talentsChartData: ITalentsData[]
  patientDetail: any
  value: number
  currentPatient:
    | (IChild & {
        formsFinished?: boolean
        formsStarted?: boolean
        gamesFinished?: boolean
        currentAssessment?: string | number
        patientId: string
      })
    | null
  loading: boolean
  isOpenPlusOnlyPopup: boolean
  isOpenReavaluateModal: boolean
  isOpenHistoryModal: boolean
  storageData: IStorageData
  isOpenShareModal: boolean
}

interface IProps
  extends INativeProps,
    IReduxProps,
    IReduxDispatchProps,
    RouteComponentProps<{ id: string }> {
  // user: IState['user']['data']
  // userAuth: IState['user']['auth']
  currentPatient: IState['currentPatient']
}

export class PatientDetails extends React.Component<IProps, IState> {
  state: IState = {
    talentsChartData: [],
    patientDetail: null,
    value: 0,
    currentPatient: null,
    loading: true,
    isOpenPlusOnlyPopup: false,
    isOpenReavaluateModal: false,
    isOpenHistoryModal: false,
    storageData: {},
    isOpenShareModal: false
  }

  hashes = ['cognitions', 'notifications', 'profile']
  careHashes = [
    'cognitions',
    'forms',
    'reports_list',
    'profile_publications',
    'profile_forms'
  ]

  componentDidMount() {
    const { currentPatient } = this.props

    this.setMixpanelData(currentPatient)

    if (currentPatient && this.props.childListener) {
      this.updState(currentPatient)
      this.checkCurrPatientData(currentPatient)
    }

    this.checkForNewAssessment(currentPatient)
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      currentPatient,
      location: { hash: locationHash },
      plusUser: currPlusUser
    } = this.props
    const {
      currentPatient: prevCurrPatient,
      location: { hash: prevLocationHash },
      plusUser: prevPlusUser
    } = prevProps

    const assessment = currentPatient && getCurrentAssessment(currentPatient)
    const prevAssessment =
      prevCurrPatient && getCurrentAssessment(prevCurrPatient)

    const { isOpenPlusOnlyPopup: currIsOpenPlusOnlyPopup } = this.state

    const { isOpenPlusOnlyPopup: prevIsOpenPlusOnlyPopup } = prevState

    if (
      (!locationHash || (!prevLocationHash && locationHash)) &&
      currIsOpenPlusOnlyPopup === prevIsOpenPlusOnlyPopup
    ) {
      setTimeout(() => scrollTo({ top: 0 }))
    }

    if (currentPatient && currentPatient !== prevCurrPatient) {
      this.setMixpanelData(currentPatient)
      this.updState(currentPatient)
      this.checkCurrPatientData(currentPatient)
      // TODO: bad idea comparing objects - should replace it
    } else if (currPlusUser !== prevPlusUser) {
      this.getAbilities(currentPatient)
    }
    // compare old data and new talent map.
    if (
      assessment &&
      prevAssessment &&
      !isEqual(assessment.current_talent_map, prevAssessment.current_talent_map)
    ) {
      this.getAbilities(currentPatient)
    }

    this.checkForNewAssessment(currentPatient)
  }

  checkForNewAssessment(currentPatient: IState['currentPatient']) {
    const { storageData } = this.state
    const { user } = this.props
    // history-mode: 3-months-check
    const isNewAssessmentAvailable = checkForNewAssessment(
      currentPatient,
      storageData,
      (newStorageData: IStorageData) =>
        this.setState({ storageData: newStorageData })
    )

    if (isNewAssessmentAvailable && user?.role !== 'educator') {
      this.toggleReavaluateModal(true)
    }

    console.log('[PatientDetails] checkForNewAssessment', {
      isNewAssessmentAvailable
    })
  }

  openPlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: true })
  }

  closePlusOnlyPopup = () => {
    this.setState({ isOpenPlusOnlyPopup: false })
  }

  toggleReavaluateModal = (status: boolean) => {
    this.setState({ isOpenReavaluateModal: status })
  }

  toggleHistoryModal = (status: boolean) => {
    this.setState({ isOpenHistoryModal: status })
  }

  toggleShareModal = (status: boolean) => {
    this.setState({ isOpenShareModal: status })
  }

  setMixpanelData = currentPatient => {
    console.log('attempt to setMixpanelData')
    // const gamesCounter = getGamesCount(currentPatient)

    // mixpanel.people.set({
    //   'All Games Completed': gamesCounter === 0,
    //   'Single Game Completed': gamesCounter < 8
    // })

    // mixpanel.identify(this.props.userAuth?.uid)
  }

  updState = currentPatient => {
    this.setState({ currentPatient })

    this.getAbilities(currentPatient)
  }

  checkCurrPatientData = currentPatient => {
    // const { history } = this.props

    if (currentPatient?.formsFinished && currentPatient?.gamesFinished) {
      this.setState({ loading: false })
      return
    }
  }

  getAbilities = patient => {
    const { PatientsLib } = this.props

    PatientsLib.setTalentChartMap(patient, () => {
      console.log('setTalentChartMap', patient)
      this.setState({
        loading: false
      })
    })
  }

  render() {
    const {
      PatientsLib,
      user,
      currentPatient,
      talentsChartData,
      userAuth
    } = this.props
    const {
      loading,
      isOpenPlusOnlyPopup,
      isOpenReavaluateModal,
      isOpenHistoryModal,
      isOpenShareModal
    } = this.state

    return currentPatient ? (
      <>
        <ReavaluateModal
          active={isOpenReavaluateModal}
          onButtonClick={() => {
            console.log('ReavaluateModal button click')
            PatientsLib.createNewRelevantAssessment(
              currentPatient.patientId,
              (child: IChild) => {
                console.log('Child updated', { child })
                this.toggleReavaluateModal(false)
              },
              (error: string) => console.error(error)
            )
          }}
          setActive={this.toggleReavaluateModal}
          childName={currentPatient.first_name}
        />
        <HistoryModal
          active={isOpenHistoryModal}
          setActive={this.toggleHistoryModal}
          onSelectClick={(currentAssessment: number) => {
            // PatientsLib.changeRelevantAssessment(
            //   currentPatient.patientId,
            //   currentAssessment,
            //   (child: IChild) => {
            //     console.log('Child updated', { child })
            //     this.toggleHistoryModal(false)
            //   },
            //   (error: string) => console.error(error)
            // )

            PatientsLib.setCurrentAssessment(
              currentPatient.patientId,
              currentAssessment,
              () => {
                PatientsLib.setCurrentPatient(currentPatient.patientId)
                this.toggleHistoryModal(false)
              },
              (error: string) => console.error(error)
            )
          }}
          datesArr={getAssessmentKeysArr(currentPatient.assessments)}
          activeDate={currentPatient.assessments.relevant_assessment}
          currentAssessment={currentPatient.currentAssessment}
        />
        <ShareModal
          open={isOpenShareModal}
          onClose={() => this.toggleShareModal(false)}
          user={userAuth}
        />
        <Content
          toggleHistoryModal={() => this.toggleHistoryModal(true)}
          user={user}
          talentsChartData={talentsChartData}
          patientDetail={currentPatient}
          loading={loading}
          openPlusOnlyPopup={this.openPlusOnlyPopup}
          isOpenPlusOnlyPopup={isOpenPlusOnlyPopup}
          closePlusOnlyPopup={this.closePlusOnlyPopup}
          activeDate={currentPatient.currentAssessment}
          openShareModal={() => this.toggleShareModal(true)}
        />
      </>
    ) : (
      <div
        style={{
          width: '100%',
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        className="content"
      >
        <Circle />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data,
    userAuth: state.user.auth,
    currentPatient: state.patients.currentPatient,
    plusUser: state.plus_user.isPlusUser,
    talentsChartData: state.patients.talentsChartData
  }
}

const mapDispatchToProps = (dispatch): IReduxDispatchProps => {
  return {
    PatientsLib: bindActionCreators(PatientActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDetails)



// WEBPACK FOOTER //
// ./src/pages/PatientDetails/index.tsx